import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const DEFAULTS = {
  site: 'Supa Energy Hub',
  origin: 'https://supaenergyhub.com.au',
  image: 'https://supaenergyhub.com.au/logo.png',
  description:
    'Supa Energy Hub — Australian solar, battery, heat pump hot water, EV charging and electrification. Backed by the Supa Promise and the Supa Value Guarantee.',
};

/**
 * Per-page SEO + structured-data wrapper.
 *
 * Usage:
 *   <SEO
 *     title="Heat Pump Hot Water Systems"
 *     description="..."
 *     jsonLd={[{...}]}     // optional — array of JSON-LD objects
 *   />
 */
const SEO = ({ title, description, image, noIndex = false, jsonLd = [] }) => {
  const { pathname } = useLocation();
  const url = `${DEFAULTS.origin}${pathname}`;
  const fullTitle = title ? `${title} | ${DEFAULTS.site}` : `${DEFAULTS.site} — Making Sustainable Living a Reality`;
  const desc = description || DEFAULTS.description;
  const ogImg = image || DEFAULTS.image;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {!noIndex && <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImg} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={DEFAULTS.site} />
      <meta property="og:locale" content="en_AU" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImg} />

      {jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
